import api from 'mastodon/api';
import type { ApiAccountJSON } from 'mastodon/api_types/accounts';
import type { ApiStatusJSON } from 'mastodon/api_types/statuses';

/** One chat from /api/v1/direct_chats: every DM with the same people */
export interface ApiDirectChatJSON {
  id: string;
  unread: boolean;
  accounts: ApiAccountJSON[];
  last_status: ApiStatusJSON;
}

export const DIRECT_CHATS_PATH = '/api/v1/direct_chats';

/** Messages asked for at a time, as the server sends them by default */
export const PAGE_SIZE = 40;

export const fetchChats = () =>
  api()
    .get<ApiDirectChatJSON[]>(DIRECT_CHATS_PATH)
    .then((response) => response.data);

/** Newest first */
export const fetchChatMessages = (id: string, maxId?: string) =>
  api()
    .get<ApiStatusJSON[]>(`${DIRECT_CHATS_PATH}/${id}`, {
      params: { limit: PAGE_SIZE, max_id: maxId },
    })
    .then((response) => response.data);

/** Fired on window once a chat has been marked as read */
export const CHAT_READ_EVENT = 'mastodon:chat-read';

export const markChatRead = (id: string) =>
  api()
    .post(`${DIRECT_CHATS_PATH}/${id}/read`)
    .then((response) => {
      window.dispatchEvent(new Event(CHAT_READ_EVENT));
      return response;
    });

/** DMs the current account was tagged in that match a search, newest first */
export const fetchDirectSearch = (q: string, limit: number, offset = 0) =>
  api()
    .get<ApiStatusJSON[]>(`${DIRECT_CHATS_PATH}/search`, {
      params: { q, limit, offset },
    })
    .then((response) => response.data);

/** How many chats have something unread */
export const fetchUnreadChatCount = () =>
  api()
    .get<{ count: number }>(`${DIRECT_CHATS_PATH}/unread_count`)
    .then((response) => response.data.count);
